// Admin AppBarTitle.

import React from 'react';
import { Stack, Box } from '@mui/material';
import Config from '../../lib/Config';
import '../../assets/style/fonts.css';
//import { useNavigate } from 'react-router-dom';
import Typography from '@mui/material/Typography';
import Util from '../../lib/Util';


const lang = Util.get_lang();

export default () => {

   // const navigate = useNavigate();

    return (
        <Typography variant="h6" color="inherit" component="div" style={{ textAlign: 'left', fontSize: '14px', color: '#222222', flexGrow: 1, cursor: 'pointer' }} onClick={() => {Util.navigate(lang,'/')}}>
            AngelTrip &nbsp;|&nbsp;&nbsp;<span style={{fontWeight:'normal',color:'#474747'}}>Administration Console</span>
        </Typography>
    );

}